import React from 'react';
import ArticleForm from 'forms/ArticleForm';

export default (): JSX.Element => <ArticleForm />;
